export const APPROVAL_LOADING = 'APPROVAL_LOADING'
export const APPROVAL_USER_LOADED = 'APPROVAL_USER_LOADED'
export const APPROVAL_LIST_LOADED = 'APPROVAL_LIST_LOADED'
export const LOADING_MODAL = 'LOADING_MODAL'
